<template>
    <div class="w-full h-full relative">
        <Header :title="'Meine Gutscheine'" />
        <content-container class="content-container-big">
            <div class="w-full" v-if="GET_COUPONS.length == 0">
                <div
                    class="text-lg text-primary font-semibold mb-7 whitespace-pre-wrap"
                >
                    Schließe Deine erste Ausbildung ab, um hier Zugriff zu all
                    deinen Dokumenten zu erhalten.
                </div>
                <custom-button
                    class="w-full xs:w-64 h-11"
                    :text="'Jetzt durchstarten'"
                    :bgColor="'bg-primary'"
                    :textColor="'text-white'"
                    :id="'change-page-button'"
                    @click="$router.push({ name: 'Dashboard' })"
                />
            </div>
            <coupon-item
                :coupon="coupon"
                v-for="(coupon, index) in GET_COUPONS.coupons"
                :key="index"
        /></content-container>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import CustomButton from "../../components/input/CustomButton.vue";
import ContentContainer from "../../components/layout/ContentContainer.vue";
import Header from "../../components/layout/Header.vue";
import {
    HELPER_TYPES,
    STORE_TYPES,
    CERTIFICATE_TYPES,
} from "../../store/types";
import CouponItem from "./Coupon.vue";

export default defineComponent({
    name: "Coupons",
    components: { Header, CustomButton, CouponItem, ContentContainer },
    setup() {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({});

        /**
         *  Functions
         */

        async function FETCH_COUPONS() {
            return store.dispatch(
                `${STORE_TYPES.CERTIFICATES}/${CERTIFICATE_TYPES.FETCH_COUPONS}`
            );
        }

        /**
         *  Computed
         */
        const GET_COUPONS = computed(() => {
            return store.getters[
                `${STORE_TYPES.CERTIFICATES}/${CERTIFICATE_TYPES.GET_COUPONS}`
            ];
        });

        /**
         *  Created
         */

        store.commit(
            `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
            "isLoadingData"
        );
        Promise.all([FETCH_COUPONS()]).then(() => {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "isLoadingData"
            );
        });

        return { state, GET_COUPONS };
    },
});
</script>
